<template>
  <div>
    <div class="cert-header d-flex py-5">
      <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
        <div class="cert-title cert-large">Unsubscribe</div>
      </div>
    </div>
    <div class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
      <div v-if="!done && !showError" class="d-flex flex-row">
        <div>Unsubscribing your account...</div>
        <cert-progress-indicator class="mx-auto my-auto"/>
      </div>

      <cert-color-box v-if="done" title="Unsubscribed successfully" icon="done" color="success"/>
      <cert-color-box v-if="showError" title="Failed to unsubscribe" icon="error_outline" color="danger"/>
    </div>
  </div>
</template>

<script>
import CertColorBox from "@/views/cert/components/CertColorBox";
import CertProgressIndicator from "@/views/cert/components/CertProgressIndicator";
import api from "@/api";

export default {

  name: "Unsubscribe",
  components: {CertColorBox, CertProgressIndicator},
  data() {
    return {
      done: false,
      showError: false,
      param: null,
    };
  },
  methods: {
    submit() {
      api.post(`${process.env.VUE_APP_BASE_URL}unsubscribe?email=${this.param}`)
          .then((response) => {
            response;
            this.done = true;
            this.showError = false;
          })
          .catch((error) => {
            error;
            this.done = false;
            this.showError = true;
          });
    }
  },
  created() {
    this.param = this.$route.params.param;
    this.submit();
  }
}
</script>
